import ModernDesktopHomeApp from './ModernDesktopHomeApp';

export default ModernDesktopHomeApp;
